import { render, staticRenderFns } from "./personalize.vue?vue&type=template&id=02dfaa3a&scoped=true"
import script from "./personalize.vue?vue&type=script&lang=js"
export * from "./personalize.vue?vue&type=script&lang=js"
import style0 from "./personalize.vue?vue&type=style&index=0&id=02dfaa3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dfaa3a",
  null
  
)

export default component.exports